/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"http://localhost:4100/mock-idp/realms/probonio/protocol/openid-connect/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ActiveEmployeeCreditCardDTO } from './active-employee-credit-card-dto';

/**
 * 
 * @export
 * @interface CreditCardBenefitDetailsDTO
 */
export interface CreditCardBenefitDetailsDTO {
    /**
     * 
     * @type {string}
     * @memberof CreditCardBenefitDetailsDTO
     */
    'status': CreditCardBenefitDetailsDTOStatusEnum;
    /**
     * use GET /cards/active
     * @type {Array<ActiveEmployeeCreditCardDTO>}
     * @memberof CreditCardBenefitDetailsDTO
     * @deprecated
     */
    'activeCreditCards': Array<ActiveEmployeeCreditCardDTO>;
    /**
     * 
     * @type {string}
     * @memberof CreditCardBenefitDetailsDTO
     */
    'nonCashBenefitUsageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreditCardBenefitDetailsDTO
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreditCardBenefitDetailsDTO
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreditCardBenefitDetailsDTO
     */
    'deadlineDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreditCardBenefitDetailsDTO
     */
    'nextStartDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreditCardBenefitDetailsDTO
     */
    'nextEndDate': string;
    /**
     * 
     * @type {number}
     * @memberof CreditCardBenefitDetailsDTO
     */
    'monthlyBudget': number;
    /**
     * 
     * @type {number}
     * @memberof CreditCardBenefitDetailsDTO
     */
    'cardBalance': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreditCardBenefitDetailsDTO
     */
    'currentlyActivated'?: boolean;
}

export const CreditCardBenefitDetailsDTOStatusEnum = {
    Inactive: 'INACTIVE',
    Pending: 'PENDING',
    Active: 'ACTIVE',
    Expiring: 'EXPIRING',
    TooLate: 'TOO_LATE'
} as const;

export type CreditCardBenefitDetailsDTOStatusEnum = typeof CreditCardBenefitDetailsDTOStatusEnum[keyof typeof CreditCardBenefitDetailsDTOStatusEnum];


